'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlexItem = exports.Flex = undefined;

var _flex = require('./flex');

var _flex2 = _interopRequireDefault(_flex);

var _flex_item = require('./flex_item');

var _flex_item2 = _interopRequireDefault(_flex_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//1.0.0 components

exports.Flex = _flex2.default;
exports.FlexItem = _flex_item2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/flex/index.js
// module id = 2212
// module chunks = 0